<div class="card">
    <div class="card card-header">
        <h3>Password Policy</h3>
    </div>
    <div class="card card-body">
        <ul>
            <li>Password must have minimum length of 12 characters and maximum 30 characters.</li>
            <li>Password must contain at least one lower case[a-z] and at least one uppercase alphabet[A-Z].</li>
            <li>Password must contain at least one special character</li>
            <li>Password must contain at least one digit[0-9]</li>
            <li>New password should not be among last five passwords.</li>
        </ul>
    </div>
</div>